import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AlertTypes, ClinicalLogTypes } from 'constants/enums';
import { logoutWithDelay } from 'store/oauth/service';
import { removeDuplicatedAlerts } from 'utils/Helpers/Alerts';

export const initialState: IClinicalLoggerState = {
  alerts: {
    [AlertTypes.MEDICAL]: [],
    [AlertTypes.COMPLIANCE]: []
  },
  tasks: [],
  manualTime: false,
  manualPost: false,
  refresh: false,
  types: [],
  notesOnly: false
};

const slice = createSlice({
  name: 'clinicalLogger',
  initialState,
  reducers: {
    onChangeSelection: (
      state,
      action: PayloadAction<{ alerts: IPatientAlerts[]; type: AlertTypes }>
    ) => {
      const newAlerts: IPatientAlerts[] = [];
      action.payload.alerts.map((alert) => {
        !newAlerts.find((item) => item.alert_id === alert.alert_id) && newAlerts.push(alert);
        alert.subRows?.map((subrow) =>
          // if subrow is selected (i.e. in payload), push subrow in alerts
          // action.payload.alerts.find((item) => item.alert_id === subrow.alert_id) &&
          newAlerts.push(subrow)
        );
      });
      state.alerts[action.payload.type] = newAlerts;
    },
    onChangeSelectionAlerts: (
      state,
      action: PayloadAction<{ alerts: IPatientAlerts[]; type: AlertTypes }>
    ) => {
      state.alerts[action.payload.type] = action.payload.alerts;
    },
    onChangeSelectionTasks: (state, action: PayloadAction<ITask[]>) => {
      state.tasks = action.payload;
    },
    clearTasksSelection: (state) => {
      state.tasks = initialState.tasks;
    },
    clear: (state) => {
      const preservedNotesOnly = state.notesOnly;

      return {
        ...initialState,
        notesOnly: preservedNotesOnly
      };
    },
    resetSelection: (state) => {
      state.alerts = {
        [AlertTypes.MEDICAL]: [],
        [AlertTypes.COMPLIANCE]: []
      };
      state.tasks = [];
    },
    setManualTime: (state, action: PayloadAction<{ manualTime: boolean }>) => {
      state.manualTime = action.payload.manualTime;
    },
    setManualPost: (state, action: PayloadAction<boolean>) => {
      state.manualPost = action.payload;
    },
    setRefresh: (state, action: PayloadAction<{ refresh: boolean }>) => {
      state.refresh = action.payload.refresh;
    },
    setClinicalLogTypes: (state, action: PayloadAction<{ types: ClinicalLogTypes[] }>) => {
      state.types = action.payload.types;
    },
    setNotesOnly: (state, action: PayloadAction<{ notesOnly: boolean }>) => {
      state.notesOnly = action.payload.notesOnly;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(logoutWithDelay.fulfilled, () => initialState);
  }
});

const getAlerts = (state: IAppState) => {
  return removeDuplicatedAlerts(Object.values(state.clinicalLogger.alerts).flat());
};

export const {
  onChangeSelection,
  onChangeSelectionTasks,
  clearTasksSelection,
  onChangeSelectionAlerts,
  clear,
  setManualTime,
  setManualPost,
  setRefresh,
  setClinicalLogTypes,
  setNotesOnly,
  resetSelection
} = slice.actions;
export const clinicalLoggerReducer = slice.reducer;
export { getAlerts };
